import { useLazyQuery } from "@apollo/client";
import { clientNeoAuth } from "@neonumy/api-clients";
import * as Sentry from "@sentry/browser";
import { GET_USER_ACCESS_QUERY } from "queries/neoauth/users";
import { useEffect, useRef, useState } from "react";
import { onErrorGraphql } from "utils/onErrorGraphql";

export function useUserAccess({ userId }: { userId: ID }) {
  const accountingFirmsId = useRef<ID[] | undefined>(undefined);
  const [dataSource, setDataSource] = useState<ListAccountingFirmsAccess[]>([]);

  const [
    listAccountingFirmsAccess,
    { data: userAccessData, error: userAccessError, refetch, loading },
  ] = useLazyQuery<ListAccountingFirmsAccessOutput, ListAccountingFirmsAccessInput>(
    GET_USER_ACCESS_QUERY,
    { client: clientNeoAuth },
  );

  useEffect(() => {
    if (userAccessData) {
      const { getUserAccesses } = userAccessData;
      if (
        getUserAccesses?.accountingFirms?.length === undefined ||
        getUserAccesses?.accountingFirms?.length === 0
      ) {
        Sentry.captureException(new Error("Invalid accounting firm access"), {
          extra: {
            response: getUserAccesses,
            accountingFirm: getUserAccesses?.accountingFirms,
          },
        });
      }
      accountingFirmsId.current = getUserAccesses.accountingFirms.map(item => item.id);
      setDataSource(
        getUserAccesses.accountingFirms
          .filter(item => !!item)
          .map(item => ({
            key: item?.id,
            id: item?.id,
            accountingFirm: item?.name,
          })),
      );
    }
  }, [userAccessData]);

  useEffect(() => {
    if (userAccessError) onErrorGraphql(userAccessError);
  }, [userAccessError]);

  useEffect(() => {
    if (userId) {
      listAccountingFirmsAccess({ variables: { id: userId } });
    }
  }, [userId]);

  return { dataSource, refetch, loading, accountingFirmsId };
}
